import React from 'react';
import { Row, Content, Message } from 'components/lib';
import {useEffect} from 'react';

export function GatewayError(props) {

    useEffect(() => {
		document.title = props.t('error.502.title')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

    return (
        <Row>
            <Content>
                <Message
                    type='error'
                    title={props.t('error.502.title')}
                    text={props.t('error.502.text')}
					buttonText={props.t('error.502.button')}
                    buttonLink='/navigate'
                />
            </Content>
        </Row>
    );
}